import type { FaireProductEntity } from "../../entity_types/product";

export const p_efh6wgp3rm: FaireProductEntity = {
  token: "p_efh6wgp3rm",
  type: "product",
  name: "Ocean Memories Gold Shell Locket Necklace",
  brandName: "ZAD",
  imageUrl:
    "https://cdn.faire.com/fastly/92f3b73946568267f3b895d239ec3afdc092fe5c2d945189fa98edff5a4cd4a8.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/90952c1478ae719dff9726b435b83b0a77bac11b41dcc5c2c33a70f247e45f7c.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
